import React, { useEffect, useRef, useState } from "react";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { OMSDropdown } from "../../../../app/common/common-components/OMSDropdown";
import TaskModel from "../../common/TaskModel";
import ConfirmationModalPopup from "../../../../app/common/common-components/ModalPopups/ConfirmationModalPopup";
import { ToPriceString } from "../../../../app/common/common-functions/functions";
import Stepper from "react-stepper-horizontal"

const DealOverviewStepView = (props) => {
  const overviewTaskModelRef = useRef();
  const [tasksStageDD, setTasksStageDD] = useState([
    {
      text: "",
      value: "",
    },
  ]);
  const [taskCounts, setTaskCounts] = useState({
    Completed: 0,
    InProgress: 0,
    NotStarted: 0,
    Issue: 0,
    Overdue: 0
  });

  const [assignedRolesDD, setAssignedRolesDD] = useState([
    {
      text: "",
      value: "",
    },
  ]);
  const [taskData, setTaskData] = useState([]);
  const [confirmationModalProps, setConfirmationModalProps] = useState({
    showModal: false,
    isConfirmed: (result) => { },
    title: "",
    body: "",
  });

  // Model Open Handles
  const onTaskITemClick = (stage, curTask) => {
    overviewTaskModelRef.current.onModelClick(stage, curTask);
  };
  // Edit Handles
  const onTaskEditSave = (isTaskDelete, task, curStage, prevStage) => {
    if (isTaskDelete) {
      var md = {
        showModal: true,
        isConfirmed: (result) => {
          deleteTaskCallback(result, curStage, task.taskId);
        },
        title: "Delete Task",
        body: "Are you sure you want to delete this Task? This cannot be undone.",
      };
      setConfirmationModalProps(md);
    } else {
      const newData = [...taskData];
      const prevStageIndex = newData.findIndex((stage) => stage.stageName === prevStage);
      const curStageIndex = newData.findIndex((stage) => stage.stageName === curStage);

      if (curStageIndex != -1) {
        if (prevStageIndex != -1) {
          const prevTaskIndex = newData[prevStageIndex].stageTasks.findIndex((ele) => ele.taskId === task.taskId);
          if (prevTaskIndex != -1) {
            newData[prevStageIndex].stageTasks.splice(prevTaskIndex, 1);
          }
        }

        newData[curStageIndex].stageTasks = [...newData[curStageIndex].stageTasks, task];
        setTaskData(newData);
        props.onDataChange(newData);
      }
    }
  };

  // Task Delete Handle
  const deleteTaskCallback = (result, stage, taskId, status) => {
    setConfirmationModalProps({
      showModal: false,
      isConfirmed: (result) => { },
      title: "",
      body: "",
    });
    if (result) {
      const newData = [...taskData];
      const stageIndex = newData.findIndex((ele) => ele.stageName === stage);
      if (stageIndex != -1) {
        const taskIndex = newData[stageIndex].stageTasks.findIndex((ele) => ele.taskId === taskId);
        if (taskIndex != -1) {
          newData[stageIndex].stageTasks.splice(taskIndex, 1);
          setTaskData(newData);
          props.onDataChange(newData);
        }
      }
      overviewTaskModelRef.current.onModelHide();
    } else {
    }
  };

  // Other Functions
  const dateFormater = (inputDateStr) => {
    const parts = inputDateStr.split("-");
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];
    const inputDate = new Date(year, month - 1, day);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const dayOfMonth = inputDate.getDate();
    const abbreviatedMonth = monthNames[inputDate.getMonth()];
    const fullYear = inputDate.getFullYear();
    const formattedDateStr = `${dayOfMonth} ${abbreviatedMonth} ${fullYear}`;
    return formattedDateStr;
  };
  const dateFormater2 = (inputDateStr) => {
    const parts = inputDateStr.split("-");
    const year = parts[0];
    const month = parts[1];
    const day = parts[2];
    const inputDate = new Date(year, month - 1, day);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const dayOfMonth = inputDate.getDate();
    const abbreviatedMonth = monthNames[inputDate.getMonth()];
    const fullYear = inputDate.getFullYear();
    const formattedDateStr = `${dayOfMonth} ${abbreviatedMonth} ${fullYear}`;
    return formattedDateStr;
  };

  const getGrossCommission = () => {
    return props.newDealData?.finance?.nettCommissionAmount + (props.newDealData?.finance?.isAddVAT ? props.newDealData?.finance?.nettCommissionAmount * 0.15 : 0);
  };

  useEffect(() => {
    setTaskData(props.data);
    if (props.data) {
      const stages = props.data?.map((curEle) => {
        return { value: curEle.stageName, text: curEle.stageName };
      });
      setTasksStageDD(stages);
    }
    if (props.assignedRolesDD != 0) {
      const assignedRoles = props.assignedRolesDD?.map((curElem) => {
        return { text: curElem, value: curElem };
      });
      setAssignedRolesDD(assignedRoles);
    }

    var mCompleted = 0, mInProgress = 0, mNotStarted = 0, mIssue = 0, mOverdue = 0;


    props.data?.forEach(element => {
      if (element.stageTasks && element.stageTasks.length > 0)
        element.stageTasks?.forEach(ele => {

          if (ele.isOverdue) {
            mOverdue++;
          }

          if (ele.status <= 1) {
            mNotStarted++; //Not Started
          }
          else if (ele.status == 2) {
            mInProgress++; //In Progress
          }
          else if (ele.status == 3) {
            mIssue++; //Issue
          }
          else if (ele.status == 4) {
            mCompleted++; //Completed
          }
        });
    });

    setTaskCounts({
      Completed: mCompleted,
      InProgress: mInProgress,
      NotStarted: mNotStarted,
      Issue: mIssue,
      Overdue: mOverdue
    });

  }, [props]);
  return (
    <>
      {props?.newDealData?.dealID ? (
        <div className="col-md-12">
          <div className="media">
            <div className="media-left">
              <span>
                <i className="fa fa-home"></i>
                <br />
                Listing
              </span>
            </div>
            <div className="media-body">
              <div className="" style={{ marginTop: 10, marginLeft: 10 }}>
                <div
                  className="color-oms"
                  style={{ fontSize: "18px", cursor: "pointer" }}
                  onClick={() => props.goToProperty()}
                >{`#${props.newDealData?.dealRef}`}</div>
                <div className="ellipsis-div">{`${props.newDealData?.propertyAddress}`}</div>
              </div>
            </div>
          </div>
          <div className="media">
            <div className="media-left">
              <span>
                <i className="fa fa-bullseye"></i>
                <br />
                Milestone
              </span>
            </div>
            <div className="media-body">
              <div className="ellipsis-container" style={{ marginTop: 10, marginLeft: 0 }}>
                <div>
                  <Stepper
                    steps={
                      props.newDealData?.stages?.length != 0 ? props.newDealData?.stages?.filter((curStage) => { return curStage.stageName != "No Milestone" }).map((curStage) => { return { title: curStage.stageName } }) : []
                    }
                    activeStep={
                      props.newDealData?.stages?.findIndex((curStage) => { return curStage.stageName == props.newDealData?.dealStage }) != -1 ? props.newDealData?.stages?.findIndex((curStage) => { return curStage.stageName == props.newDealData?.dealStage }) : 0
                    }
                    activeColor={"#92ab1c"}
                    completeColor={"#000"}
                    defaultColor={"#000"}
                    activeTitleColor={"#000"}
                    completeTitleColor={"#000"}
                    defaultTitleColor={"#000"}
                    size={20}
                    circleFontSize={0}
                    barStyle={"solid"}
                    defaultBorderStyle={"solid"}
                    completeBorderStyle={"solid"}
                    activeBorderStyle={"solid"}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="media">
            <div className="media-left">
              <span>
                <i className="fa fa-clock-o"></i>
                <br />
                Tasks
              </span>
            </div>
            <div className="media-body">
              <div style={{ marginTop: 10, marginLeft: 10 }}>
                <div className="d-flex">
                  <span className="" style={{ textOverflow: "clip" }}>
                    <b style={{ whiteSpace: "nowrap", marginLeft: "4px" }}>{taskCounts.Completed} Completed | </b>
                  </span>
                  <span className="" style={{ textOverflow: "clip" }}>
                    <b style={{ whiteSpace: "nowrap", marginLeft: "4px" }}>{taskCounts.InProgress} In Progress | </b>
                  </span>
                  <span className="" style={{ textOverflow: "clip" }}>
                    <b style={{ whiteSpace: "nowrap", marginLeft: "4px" }}>{taskCounts.NotStarted} Not Started | </b>
                  </span>
                  <span className="" style={{ textOverflow: "clip" }}>
                    <b style={{ whiteSpace: "nowrap", marginLeft: "4px" }}>{taskCounts.Issue} Issue</b>
                  </span>
                </div>
                <div className="d-flex" style={{ marginTop: 10 }}>
                  <span className="" style={{ textOverflow: "clip" }}>
                    <i className="fa fa-exclamation-triangle" style={{ marginTop: 5, marginRight: 8, fontSize: 14, color: 'red' }} aria-hidden="true"></i>
                    <b style={{ whiteSpace: "nowrap", marginLeft: "2px" }}>{taskCounts.Overdue == 0 ? "No tasks overdue" : taskCounts.Overdue + " tasks overdue"}</b>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="media">
            <div className="media-left">
              <span>
                <i className="fa fa-address-book"></i>
                <br />
                Contacts
              </span>
            </div>
            <div className="media-body">
              <div className="" style={{ marginTop: 10, marginLeft: 10 }}>
                {
                  props.contacts?.map((curContact, i) => {
                    return <div key={i} className="my-2">
                      <b>{`${curContact.contactType}:`}</b><span>{curContact.displayName}</span>
                    </div>
                  })
                }
              </div>
            </div>
          </div>
          <div className="media">
            <div className="media-left">
              <span>
                <i className="fa fa-pie-chart"></i>
                <br />
                Finance
              </span>
            </div>
            <div className="media-body">
              <div className="" style={{ marginTop: 10, marginLeft: 10 }}>
                <div className="">
                  <b>{`${props.currency}${ToPriceString(props.newDealData?.finance?.askingPrice)}`}</b>
                </div>
                <div className="">
                  <b>
                    <h3 style={{ margin: "5px 0px" }}>{`${props.currency}${getGrossCommission()} GC`}</h3>
                  </b>
                </div>
                <div className="split_overview_card_container">
                  {
                    props.newDealData?.finance?.splits?.map((curSplit, i) => {
                      if (curSplit.userID == props.userSession.userId){
                      return <div key={i} className={`split_overview_card my-1 mr-2`}>
                        <span className="p-1">{curSplit.userName}</span>
                        <div className="btn btn-success-oms">{`${props.currency}${ToPriceString(curSplit.amount)}(${curSplit.percentage}%)`}</div>
                      </div>
                    }
                  })
                  }

                </div>
              </div>
            </div>
          </div>
        </div>
        // <div className="col-md-12">
        //   <div>
        //     <p className="tag3">
        //       deal on{" "}
        //       <a
        //         style={{ color: "white", cursor: "pointer" }}
        //         onClick={() => {
        //           props.goToProperty();
        //         }}
        //       >
        //         {props.newDealData.propertyAddress}
        //       </a>
        //     </p>
        //   </div>
        //   <div className="overview">
        //     <VerticalTimeline lineColor={"black"} layout={"1-column-left"} animate={true}>
        //       <VerticalTimelineElement
        //         className="vertical-timeline-element--work m-o"
        //         iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
        //         icon={<i className="fa fa-solid fa-bullseye"></i>}
        //       >
        //         <h5 className="vertical-timeline-element-title">
        //           <b>Deal</b> created on <b>{dateFormater(props?.newDealData?.startDate)}</b>
        //         </h5>
        //       </VerticalTimelineElement>
        //       <br />
        //       <div className="tasks">
        //         {props?.data?.map((curStage, i) => {
        //           if (curStage.stageExpected) {
        //             return (
        //               <div key={i}>
        //                 <VerticalTimelineElement
        //                   className="vertical-timeline-element--work"
        //                   iconStyle={{ background: "rgb(33, 150, 243)", color: "#000", textAlign: "center", background: "white" }}
        //                   icon={
        //                     <b>
        //                       {curStage.stageExpected
        //                         ? dateFormater(curStage.stageExpected).split(" ")[1] + " " + dateFormater(curStage.stageExpected).split(" ")[0]
        //                         : ""}
        //                     </b>
        //                   }
        //                 >
        //                   <h5 style={{ marginTop: 25 }}>
        //                     <b>{curStage.stageName}</b>
        //                   </h5>
        //                   {curStage.stageTasks.map((curTask, i) => {
        //                     return (
        //                       <div key={i} className={`task-overview mt-1  d-flex align-items-center justify-content-between bg${curTask.status}statusO`}>
        //                         <div className="d-flex flex-column">
        //                           <h5 onClick={() => onTaskITemClick(curStage.stageName, curTask)}>
        //                             {curTask.taskName}
        //                             {curTask.taskDueDate ? <b>&nbsp; due on {dateFormater2(curTask.taskDueDate)}</b> : null}
        //                           </h5>
        //                           <div>
        //                             {curTask.assignedRoles?.map((curRole, i) => {
        //                               return (
        //                                 <span key={i} className={`tag1_sm bgtag${curRole.assignedRole}`} style={{ marginLeft: i !== 0 ? "5px" : "" }}>
        //                                   {`${curRole.assignedRole}${curRole.name && curRole.name?.length > 0 ? ":" : ""} ${curRole.name?.map((curEle) => {
        //                                     return " " + curEle;
        //                                   })}`}
        //                                 </span>
        //                               );
        //                             })}
        //                           </div>
        //                         </div>
        //                       </div>
        //                     );
        //                   })}
        //                 </VerticalTimelineElement>
        //               </div>
        //             );
        //           } else {
        //             return curStage.stageName == "No Milestone" && curStage.stageTasks.length == 0 ? (
        //               ""
        //             ) : (
        //               <div key={i}>
        //                 <VerticalTimelineElement
        //                   className="vertical-timeline-element--work"
        //                   iconStyle={{ display: "none" }}
        //                   icon={
        //                     <b>
        //                       {curStage.stageExpected
        //                         ? dateFormater(curStage.stageExpected).split(" ")[1] + " " + dateFormater(curStage.stageExpected).split(" ")[0]
        //                         : ""}
        //                     </b>
        //                   }
        //                 >
        //                   <h5 style={{ marginTop: 25 }}>
        //                     <b>{curStage.stageName}</b>
        //                   </h5>
        //                   {curStage.stageTasks.map((curTask, i) => {
        //                     return (
        //                       <div key={i} className={`task-overview mt-1  d-flex align-items-center justify-content-between bg${curTask.status}statusO`}>
        //                         <div className="d-flex flex-column">
        //                           <h5 onClick={() => onTaskITemClick(curStage.stageName, curTask)}>{curTask.taskName}</h5>
        //                           <div>
        //                             {curTask.assignedRoles?.map((curRole, i) => {
        //                               return (
        //                                 <span key={i} className={`tag1_sm bgtag${curRole.assignedRole}`} style={{ marginLeft: i !== 0 ? "5px" : "" }}>
        //                                   {`${curRole.assignedRole}${curRole.name && curRole.name?.length > 0 ? ":" : ""} ${curRole.name?.map((curEle) => {
        //                                     return " " + curEle;
        //                                   })}`}
        //                                 </span>
        //                               );
        //                             })}
        //                           </div>
        //                         </div>
        //                       </div>
        //                     );
        //                   })}
        //                 </VerticalTimelineElement>
        //               </div>
        //             );
        //           }
        //         })}
        //       </div>
        //     </VerticalTimeline>
        //   </div>
        // </div>
      ) : (
        <div className="col-md-6">
          <div className="form-group">
            <label>Enter a name for this deal</label>
            <input
              name="deal_name"
              type="text"
              className="form-control"
              value={props?.dealModelData.dealname}
              disabled={props.newDealData?.dealID ? true : false}
              onChange={(e) => props?.inputHandler(e, "dealName")}
            />
          </div>
          <div className="form-group">
            <label>Reference / start date</label>
            <input
              name="deal_date"
              type="date"
              className="form-control"
              value={props?.dealModelData.dealDate}
              disabled={props?.newDealData?.dealID ? true : false}
              onChange={(e) => props?.inputHandler(e, "dealDate")}
            />
          </div>
          <div className="form-group">
            <label>Select a Pipeline</label>
            <OMSDropdown
              id="pipeline"
              options={props?.dealPipelineDD}
              valueField="value"
              labelField="text"
              value={props?.dealModelData.pipelineId}
              disabled={props?.newDealData?.dealID ? true : false}
              onChange={(e) => props?.inputHandler(e, "dealPipeline")}
            />
          </div>
          <div className="form-group">
            <label>Select a template (optional)</label>
            <OMSDropdown
              id="templete"
              options={props?.dealTEmpleteDD}
              valueField="template"
              labelField="template"
              disabled={props?.newDealData?.dealID ? true : false}
              value={props?.dealModelData.dealTemplete}
              onChange={(e) => props?.inputHandler(e, "dealTemplete")}
            />
          </div>

          <div className="form-group">
            <label>Update listing status</label>
            <select id="mandateStatus" name="mandateStatus" className="form-control" value={props?.dealModelData.mandateStatus} onChange={(e) => props?.inputHandler(e, "mandateStatus")}>
            <option value="0">No update</option>
                    <option value="1">Active</option>
                    <option value="2">Expired</option>
                    <option value="3">Withdrawn</option>
                    <option value="4">Rented</option>
                    <option value="5">Sold - Under Offer</option>
                    <option value="6">Sold - Registered</option>
                    <option value="7">Sold - Cancelled</option>
                    <option value="8">Inactive</option>
                  </select>
            
          </div>



         
        </div>
      )}

      {/* Model */}
      <TaskModel
        modelId="overviewTaskModel"
        ref={overviewTaskModelRef}
        isTaskEdit={true}
        isBreadCrumb={false}
        tasksStageDD={tasksStageDD}
        assignedRolesDD={assignedRolesDD}
        onSave={() => { }}
        onEdit={onTaskEditSave}
        onDataChange={props.onDataChange}
        contacts={props.contacts}
        syncId={props.syncId}
        accessType={props.accessType}
      />
      <ConfirmationModalPopup {...confirmationModalProps} />
    </>
  );
};

export default DealOverviewStepView;
